export default "__VITE_ASSET__qn8A0WIy__"